module.exports = __webpack_public_path__ + "img/logo.999357f4.png";